import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_2 = { class: "modal-content" };
const _hoisted_3 = { class: "modal-header border-0 pb-0" };
const _hoisted_4 = ["aria-label"];
const _hoisted_5 = { class: "modal-body pt-2" };
const _hoisted_6 = { class: "text-uppercase text-danger small fw-bold mb-2" };
const _hoisted_7 = {
    id: "survey-required-title",
    class: "h5"
};
const _hoisted_8 = { class: "text-muted mb-0" };
const _hoisted_9 = { class: "modal-footer border-0 pt-0" };
const _hoisted_10 = {
    key: 1,
    class: "modal-backdrop fade show"
};
import { useI18n } from "vue-i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SurveyRequiredPrompt',
    props: {
        show: { type: Boolean },
        count: {},
        surveyTitle: {}
    },
    emits: ["respond", "later"],
    setup(__props) {
        const { t } = useI18n();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_ctx.show)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "modal fade show survey-required-prompt",
                        style: { "display": "block" },
                        tabindex: "-1",
                        role: "dialog",
                        "aria-modal": "true",
                        "aria-labelledby": "survey-required-title",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.$emit('later')), ["self"]))
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _cache[4] || (_cache[4] = _createElementVNode("span", {
                                        class: "survey-required-prompt__icon",
                                        "aria-hidden": "true"
                                    }, [
                                        _createElementVNode("i", { class: "bi bi-clipboard2-check" })
                                    ], -1)),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "aria-label": _unref(t)('surveys.prompt.laterAria'),
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('later')))
                                    }, null, 8, _hoisted_4)
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)("surveys.prompt.eyebrow")), 1),
                                    _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.surveyTitle || _unref(t)("surveys.prompt.fallbackTitle")), 1),
                                    _createElementVNode("p", _hoisted_8, [
                                        _createTextVNode(_toDisplayString(_unref(t)("surveys.prompt.message")) + " ", 1),
                                        (_ctx.count > 1)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(_toDisplayString(_unref(t)("surveys.prompt.multiple", { count: _ctx.count })), 1)
                                            ], 64))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-outline-secondary",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('later')))
                                    }, _toDisplayString(_unref(t)("surveys.prompt.later")), 1),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-primary",
                                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('respond')))
                                    }, _toDisplayString(_unref(t)("surveys.prompt.respondNow")), 1)
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.show)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
